import { atom } from "jotai";

import { getBookingDurationAtom } from "../../../../atoms/selectors/getBookingDurationAtom/getBookingDurationAtom";
import { getStartSlotIdFromCourt } from "../../../../components/EditableRoundsStep/components/BookingDurationCourt/atoms/selectors/getStartSlotIdFromCourt";
import { UpdateMultiSlotBookingInput } from "../../../../hooks/saveChangesHooks/useSaveChangesToMultiSlotBooking/__generated__/useSaveChangesToMultiSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../stores";
import { updatedCustomerRoundsAtom } from "../UpdatedRounds/UpdatedCustomerRounds/UpdatedCustomerRoundsAtom";
import { updatedGuestRoundsAtom } from "../UpdatedRounds/UpdatedGuestRoundsAtom/UpdatedGuestRoundsAtom";
import { updatedMemberRoundsAtom } from "../UpdatedRounds/UpdatedMemberRoundsAtom/UpdatedMemberRoundsAtom";
import { updatedNewGuestRoundsAtom } from "../UpdatedRounds/UpdatedNewGuestRoundsAtom/UpdatedNewGuestRoundsAtom";

export const updateDurationBookingPayloadAtom =
  atom<UpdateMultiSlotBookingInput | null>((get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const isPrivate = currentBooking.isPrivate;
    const updatedCustomerRounds = get(updatedCustomerRoundsAtom);
    const updatedMemberRounds = get(updatedMemberRoundsAtom);
    const updatedGuestRounds = get(updatedGuestRoundsAtom);
    const updatedNewGuestRounds = get(updatedNewGuestRoundsAtom);
    const duration = get(getBookingDurationAtom);
    const ownerRound = currentBooking.rounds.find((r) => r.isOwner);
    const ownerClientId = ownerRound?.player?.id;
    const startSlotId = currentBooking.startSlotId;
    // get the start slot id from the court (when and if we changed courts)
    const changedStartSlotId = get(getStartSlotIdFromCourt);
    // get the duration (when and if we changed duration)
    const changedDuration = duration ?? undefined;

    const input: UpdateMultiSlotBookingInput = {
      bookingId: currentBooking.id,
      notifyMember: false,
      customerRounds: isPrivate ? undefined : updatedCustomerRounds,
      memberRounds: isPrivate ? updatedMemberRounds : undefined,
      guestRounds: isPrivate ? updatedGuestRounds : undefined,
      newGuestRounds: isPrivate ? updatedNewGuestRounds : undefined,
      startSlotId: changedStartSlotId ?? startSlotId ?? "",
      durationMins: changedDuration ?? undefined,
      ownerClientId: ownerClientId ?? undefined,
      rateId: currentBooking.rateId,
      request: currentBooking.request
        ? {
            time: currentBooking.request.time || "",
            minTime: currentBooking.request.minTime || "",
            maxTime: currentBooking.request.maxTime || "",
          }
        : undefined,
    };

    return input;
  });
